<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div style="display: flex; justify-content: space-between; margin-bottom: 15px;">
          <button class="btn btn-primary" @click="openClientModal(null)">Добавить клиента</button>
          <div style="display: flex; align-items: center;">
            <argon-input
                placeholder="Поиск"
                v-model="searchText"
                @input="setSearchText"
                @keyup.enter="startSearch"
                style="margin-right: 10px;"
            />
            <SortTemplate :options="sortOptions" v-model:sortValue="clientSort" :change-sort-action="setSortType"/>
            <button class="btn btn-primary" @click="startSearch">Искать</button>
          </div>
        </div>

        <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div v-if="isLoading">
            <CircleProgress/>
          </div>
        </transition>

        <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div class="card container-fluid mt-3">
            <div class="card-header pb-0">
              <h6>Клиенты <span v-if="clients.length">({{ clients.length }})</span></h6>
            </div>
            <div v-if="!isLoading">
              <div class="card-body px-0 pt-0 pb-2">
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">ID</th>
                      <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">ФИО
                      </th>
                      <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">Дата
                        Рождения
                      </th>
                      <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">Юр.
                        лицо
                      </th>
                      <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">Черный
                        список
                      </th>
                      <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">
                        Статистика
                      </th>
                      <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">
                        Действия
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="client in clients" :key="client.id">
                      <td>{{ client.id }}</td>
                      <td>{{ client.fullName }}</td>
                      <td>{{ client.birthdate ? formatDate(client.birthdate) : '-' }}</td>
                      <td>
                        <CustomCheckBox :value="client.isLegalEntity"/>
                      </td>
                      <td>
                        <CustomCheckBox :value="client.isInBlackList"/>
                      </td>
                      <td>

                        <button v-if="client.orders.length > 0" class="btn btn-sm btn-info"
                                @click="showClientOrders(client.orders, client)">
                          <i class="fas fa-chart-bar"></i>
                        </button>
                      </td>
                      <td>
                        <button class="btn btn-sm btn-primary" @click="openClientModal(client.id)">
                          <i class="fas fa-edit"></i>
                        </button>
                        <button class="btn btn-sm btn-danger" @click="deleteClient(client)">
                          <i class="fas fa-trash"></i>
                        </button>
                        <button class="btn btn-sm btn-warning" v-if="!client.isInBlackList" @click="addToBlacklist(client.id)">
                          В черный список
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div class="mt-2 d-flex justify-content-between align-items-center">
                  <button class="btn btn-secondary btn-sm" :disabled="clientPaginationStart <= 0" @click="previousPage">
                    Назад
                  </button>
                  <span>Страница {{ Math.floor(clientPaginationStart / clientListSize) + 1 }}</span>
                  <button class="btn btn-secondary btn-sm" :disabled="clientListSize > clients.length"
                          @click="nextPage">
                    Вперед
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <ClientFormModal
            :show="showClientModal"
            :client-id="selectedClientId"
            @close="closeClientModal"
            @saved="onClientSaved"
        />
        <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <ClientOrdersStatistic v-if="clientOrdersStatisticModal"/>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import CircleProgress from "./components/CircleProgress.vue";
import ArgonInput from "../components/ArgonInput.vue";
import SortTemplate from "../components/standart/SortTemplate.vue";
import ClientFormModal from "@/views/components/Form/ClientFormModal.vue";
import axios from "@/axios";
import CustomCheckBox from "@/views/components/CustomCheckBox.vue";
import ClientOrdersStatistic from "@/views/components/OrderComponents/ClientOrderStatistic.vue";

export default {
  name: "ClientsTableNew",
  components: {
    ClientOrdersStatistic,
    CustomCheckBox,
    CircleProgress,
    ArgonInput,
    SortTemplate,
    ClientFormModal
  },
  data() {
    return {
      clients: [],
      sortOptions: [
        {key: 'null', value: 'null', text: 'Все'},
        {key: 'ASC', value: 'ASC', text: 'От А до Я'},
        {key: 'DESC', value: 'DESC', text: 'От Я до А'},
      ],
      showClientModal: false,
      selectedClientId: null,
      selectedClientForStatistic: null,
    };
  },
  computed: {
    clientOrdersStatisticModal: {
      get() {
        return this.$store.state.clientsOrdersModal;
      }
    },
    isLoading() {
      return this.$store.state.clientsIsLoading;
    },
    searchText: {
      get() {
        return this.$store.state.clientSearchText;
      }
    },
    clientSort: {
      get() {
        return this.$store.state.clientSortType;
      }
    },
    clientListSize: {
      get() {
        return this.$store.state.clientListSize;
      }
    },
    clientPaginationStart: {
      get() {
        return this.$store.state.clientPaginationStart;
      }
    },
  },
  methods: {
    setClientOrders(orders) {
      this.$store.commit('updateClientOrders', orders);
    },
    onClientSaved() {
      this.fetchData();
    },
    showClientOrders(data, client) {
      this.setClientOrders(data);
      this.setClientOrdersModal(true);
      this.$store.commit('updateClientOrderStatisticItem', client);
    },
    setClientOrdersModal(active) {
      this.$store.commit('updateClientsOrdersModal', active);
    },
    fetchData() {
      this.$store.commit('updateClientIsLoading', true);
      let url = `/api/clients?length=${this.clientListSize}&start=${this.clientPaginationStart}`;
      if (this.searchText && this.searchText.length >= 3) url += `&search=${this.searchText}`;
      if (this.clientSort && this.clientSort !== "null") url += `&sort=${this.clientSort}`;

      axios.get(url).then(res => {
        this.clients = res.data;
        this.$store.commit('updateClientIsLoading', false);
      }).catch(() => this.$store.commit('updateClientIsLoading', false));
    },
    startSearch() {
      this.fetchData();
    },
    setSearchText(event) {
      this.$store.commit('updateClientSearchText', event.target.value);
    },
    setSortType(sortType) {
      this.$store.commit('updateClientSortType', sortType.target.value);
    },
    openClientModal(clientId) {
      this.selectedClientId = clientId;
      this.showClientModal = true;
    },
    closeClientModal() {
      this.selectedClientId = null;
      this.showClientModal = false;
    },
    deleteClient(client) {
      axios.delete(`/api/clients/${client.id}`).then(() => this.fetchData());
    },
    addToBlacklist(clientId) {
      if (confirm("Вы уверены, что хотите внести клиента в черный список?")) {
        const reason = prompt("Пожалуйста, введите причину:");
        axios.post(`/api/clients/add-to-blacklist/${clientId}`, {reason}).then(() => this.fetchData());
      }
    },
    nextPage() {
      this.$store.commit('updateClientPaginationStart', this.clientPaginationStart + this.clientListSize);
      this.fetchData();
    },
    previousPage() {
      this.$store.commit('updateClientPaginationStart', this.clientPaginationStart - this.clientListSize);
      this.fetchData();
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("ru-RU");
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      el.style.transition = "opacity 0.5s";
      el.style.opacity = 1;
      done();
    },
    leave(el, done) {
      el.style.transition = "opacity 0.5s";
      el.style.opacity = 0;
      done();
    },
  },
  mounted() {
    this.fetchData();
  }
};
</script>


<style scoped>
.filters-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.filters-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: flex-end;
  flex: 1;
}

.table-responsive {
  overflow-y: auto;
}

.table th, .table td {
  padding: 0.5rem 0.75rem;
  vertical-align: middle;
}

.table th.header-text {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
}

td {
  font-size: 0.8rem;
  font-weight: 700;
}

.btn-sm {
  font-size: 0.7rem;
  padding: 0.25rem 0.5rem;
}
</style>